export default function dateFormatter(date){
    if(!date) return null
    return date.replace(/^(\d{4})-0?(\d{1,2})-0?(\d{1,2}).*/, '$2/$3/$1');
}